import { EyeOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React from 'react';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventIdentifier, GAEventName } from '../../../section/Common/constants';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const Watch: React.FC<IProps> = ({ book, id, label = 'Title' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={<div className='popover-content'>{`Send ${label} to Watchlist`}</div>}
      trigger='hover'
    >
      <EyeOutlined
        data-testid='action-watch-item'
        onClick={(e) => {
          e.stopPropagation();
          globalThis.gtag('event', GAEventName.click, {
            identifier: GAEventIdentifier.titletoWatchlist,
            value: book.ASIN,
            book_name: book.Title
          });
          setAction({ book, id, type: ACTIONS.watch });
        }}
        className='actions-icons actions-icons-eye'
      />
    </Popover>
  );
};

export default React.memo(Watch);
